import React, { useEffect } from "react";
import FlowNavigationSidebar from "./navigation/FlowNavigationSidebar";
import FlowContentPage from "./FlowContentPage";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { selectFlow, saveFlow } from "../../../redux/actions/integrationActions";
import { clearLog } from "../../../redux/actions/logActions";
import { useSaveShortcut } from "../../../common/utils/keybindings";
import ShareFlowLink from "../ShareFlowLink";
import { Inline } from "@atlaskit/primitives";
import SandBoxWarning from "./SandBoxWarning";
import { scrollToTop } from "../../../env/stage";
const FlowEditorPage = () => {
  const flow = useSelector((state) => state.integration.flow);
  const flows = useSelector((state) => state.integration.flows);
  const saved = useSelector((state) => state.integration.saved);

  const { flowId } = useParams();
  const dispatch = useDispatch();

  const doSave = () => {
    if (!saved) {
      dispatch(saveFlow(flow));
    }
  };

  useSaveShortcut(doSave);

  useEffect(() => {
    if (flowId) {
      const f = flows.find((f) => f.id === flowId);
      if ((f && f.id !== flow.id) || (f && !flow.id)) {
        scrollToTop();
        dispatch(selectFlow(JSON.parse(JSON.stringify(f))));
        dispatch(clearLog());
      }
    }
  }, [flowId, flow, flows]);

  return (
    <div className="ihub-edit-flow">
      <SandBoxWarning />

      <Inline align="center">
        <ShareFlowLink flowId={flow.id} />
        <h3> | {flow && flow.name}</h3>
      </Inline>
      <p className="ihub-flow-head-details">
        {flow?.description && flow.description.substring(0, 120)} {flow?.description && flow.description.length >= 120 && "..."}
      </p>
      <div className="ihub-flexbox ihub-flow-editor-layout">
        <FlowNavigationSidebar />
        <FlowContentPage />
      </div>
    </div>
  );
};
export default FlowEditorPage;
